import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f9bd945"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pb-75" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "top-title",
    "data-aos": "fade-up",
    "data-aos-duration": "1200",
    "data-aos-delay": "100"
  }, "OUR BLOG"),
  /*#__PURE__*/_createElementVNode("h2", {
    title: "celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore",
    "data-aos": "fade-up",
    "data-aos-duration": "1200",
    "data-aos-delay": "200"
  }, " Your path to paid search excellence starts here! ")
], -1))
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = ["data-aos-delay"]
const _hoisted_6 = { class: "blog-single-item transition-y" }
const _hoisted_7 = { class: "flex-shrink-0" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "flex-grow-1 ms-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Posted by", -1))
const _hoisted_11 = {
  title: "celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore",
  class: "mb-0"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = { title: "celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" }
const _hoisted_14 = { class: "ps-0 mb-0 list-unstyled tags" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blogs, (blog) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xl-4 col-md-6",
            key: blog.id,
            "data-aos": "fade-up",
            "data-aos-duration": "1200",
            "data-aos-delay": blog.dataDelay
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: "/author",
                class: "d-flex align-items-center text-decoration-none author"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("img", {
                      src: blog.authorImage,
                      class: "rounded-circle",
                      alt: "author"
                    }, null, 8, _hoisted_8)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("h6", _hoisted_11, _toDisplayString(blog.name), 1)
                  ])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_router_link, {
                to: "/blog-details",
                class: "d-block blog-img"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: blog.image,
                    alt: "blog"
                  }, null, 8, _hoisted_12)
                ]),
                _: 2
              }, 1024),
              _createElementVNode("h3", _hoisted_13, [
                _createVNode(_component_router_link, { to: "/blog-details" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(blog.title), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createElementVNode("ul", _hoisted_14, [
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/blog-details" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Paid Advert")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/blog-details" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Google Search")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ], 8, _hoisted_5))
        }), 128))
      ])
    ])
  ]))
}